export { default as ToysIcon } from "./toys.svg";
export { default as SportsIcon } from "./sports.svg";
export { default as BooksIcon } from "./books.svg";
export { default as HealthIcon } from "./health.svg";
export { default as MixedIcon } from "./mixed.svg";
export { default as OtherIcon } from "./other.svg";
export { default as ShirtIcon } from "./shirt.svg";
export { default as ShoesIcon } from "./boot-heeled.svg";
export { default as GlassesIcon } from "./glasses.svg";
export { default as EBooksIcon } from "./e-book.svg";
export { default as WatchesIcon } from "./watches.svg";
export { default as BagsIcon } from "./bags.svg";
export { default as HeadphonesIcon } from "./headphones.svg";
export { default as CostumeJewelryIcon } from "./jewelry.svg";
export { default as ComputerPartsIcon } from "./computer-parts.svg";
export { default as MusicsIcon } from "./musics.svg";
export { default as GamesIcon } from "./games.svg";
export { default as PowerBankIcon } from "./power-banks.svg";
export { default as CarIcon } from "./car.svg";
export { default as MobileIcon } from "./mobile.svg";
export { default as HomeGoodsIcon } from "./goods.svg";
export { default as ComputersIcon } from "./computers-and-office-supplies.svg";
export { default as SafetyIcon } from "./safety-and-protection.svg";
export { default as BabiesIcon } from "./for-babies.svg";
export { default as OfficeAndStationeryIcon } from "./office-and-stationery.svg";
export { default as FurnitureIcon } from "./furniture.svg";
export { default as MedicationsIcon } from "./medications.svg";
export { default as MusicInstrumentsIcon } from "./musical-instruments.svg";
export { default as LightingIcon } from "./lighting.svg";
export { default as FoodIcon } from "./food-products.svg";
export { default as ConstructionIcon } from "./construction.svg";
export { default as JewelryIcon } from "./jewelry.svg";
export { default as ForBabyIcon } from "./for-baby.svg";
export { default as BooksGeIcon } from "./books-ge.svg";
export { default as MusicMovieIcon } from "./movies_music.svg";
export { default as Jewelry2Icon } from "./jewelry-2.svg";
export { default as PhonePartsIcon } from "./phone-parts.svg";
export { default as Ebook2Icon } from "./e-book2.svg";
export { default as TabletIcon } from "./tablet.svg";
export { default as VariousGoodsIcon } from "./various_goods.svg";
export { default as GadgetsIcon } from "./gadgets.svg";
